module.exports = __webpack_public_path__ + "static/media/cover-israel.ce9db058.jpg";